"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfirmContainer = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _layout = _interopRequireDefault(require("./layout"));

var ConfirmContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ConfirmContainer, _Component);

  var _super = (0, _createSuper2["default"])(ConfirmContainer);

  function ConfirmContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ConfirmContainer);
    _this = _super.call(this, props);

    _this.onClick = function (actionToConfirm) {
      return _this.setState({
        isOpen: true,
        actionToConfirm: actionToConfirm
      });
    };

    _this.onClose = function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.setState({
        isOpen: false,
        actionToConfirm: null
      });
    };

    _this.onConfirm = function (e) {
      var actionToConfirm = _this.state.actionToConfirm;

      if (e) {
        e.stopPropagation();
      }

      actionToConfirm();

      _this.onClose();
    };

    _this.state = {
      isOpen: false,
      actionToConfirm: null
    };
    return _this;
  }

  (0, _createClass2["default"])(ConfirmContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_layout["default"], Object.assign({}, this.props, this.state, {
        onConfirm: this.onConfirm,
        onClose: this.onClose,
        onClick: this.onClick
      }));
    }
  }]);
  return ConfirmContainer;
}(_react.Component);

exports.ConfirmContainer = ConfirmContainer;
var _default = ConfirmContainer;
exports["default"] = _default;